import React from 'react';

// Padrões de largura por linha — determinísticos para evitar re-render inconsistente
const TABLE_ROW_PATTERNS = [
  [14, 28, 18, 20, 12, 8],
  [16, 24, 20, 18, 14, 8],
  [12, 30, 16, 22, 12, 8],
  [18, 26, 20, 16, 12, 8],
  [14, 28, 18, 20, 12, 8],
  [16, 24, 22, 18, 12, 8],
  [10, 30, 18, 22, 12, 8],
  [16, 26, 20, 18, 12, 8],
];

const HEADER_PATTERN = [18, 24, 18, 16, 12, 8];

export function SkeletonBar({ width = '100%', height, style, className }) {
  return (
    <div
      className={`mellro-skeleton-bar${className ? ` ${className}` : ''}`}
      style={{ width, ...(height ? { height } : {}), ...style }}
    />
  );
}

export function SkeletonTableRows({ count = 8 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => {
        const pattern = TABLE_ROW_PATTERNS[i % TABLE_ROW_PATTERNS.length];
        return (
          <div key={i} className="mellro-skeleton-row">
            {pattern.map((pct, j) => (
              <SkeletonBar key={j} width={`${pct}%`} />
            ))}
          </div>
        );
      })}
    </>
  );
}

export function SkeletonTable({ rows = 8 }) {
  return (
    <div className="mellro-skeleton-table-wrapper">
      <div className="mellro-skeleton-row mellro-skeleton-header-row">
        {HEADER_PATTERN.map((pct, i) => (
          <SkeletonBar key={i} width={`${pct}%`} height="14px" />
        ))}
      </div>
      <SkeletonTableRows count={Math.min(rows, 8)} />
    </div>
  );
}

export function SkeletonPage({ rows = 6 }) {
  return (
    <div className="mellro-skeleton-page">
      <div className="mellro-skeleton-card">
        <div className="mellro-skeleton-card-header">
          <SkeletonBar width="200px" height="18px" />
          <SkeletonBar width="100px" height="18px" />
        </div>
        <SkeletonTableRows count={rows} />
      </div>
    </div>
  );
}
